import { render, staticRenderFns } from "./addressForm.vue?vue&type=template&id=d69d0c64&"
import script from "./addressForm.vue?vue&type=script&lang=ts&"
export * from "./addressForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports